import { Tab, Tabs } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { SubNavBar } from "components/common/SubNavBar";
import { TABS } from "routing/constants";
import { RouteSpec, tabToPath } from "routing/routeSpecs";
import { User } from "types/users";

export interface SubNavTabProps {
  routeSpec: RouteSpec;
  userInfo: User;
}

export default function SubNavTabs(props: SubNavTabProps) {
  const { routeSpec, userInfo } = props;

  // The data page SubNavBar tab is only shown to superusers or regular users with the
  // "show_inspections" permission.
  const shouldRenderSubnav = routeSpec.name !== "Data" || (routeSpec.name === "Data" && userInfo.show_inspections);

  return shouldRenderSubnav ? (
    <SubNavBar className="mt-0 mx-0">
      <Tabs value={routeSpec?.subTab || false} className="-ml-4" sx={{
        "& .MuiTabs-indicator": {
          backgroundColor: (theme) => theme.palette.axon.main,
          height: "2px"
        }
      }}>
        {routeSpec.tab &&
          Object.keys(TABS[routeSpec.tab]).map((choice) => (
            <Tab
              component={Link}
              to={tabToPath(routeSpec?.tab, choice)}
              value={choice || ""}
              label={choice}
              key={choice}
              className="px-4 py-2"
              sx={{
                color: "#ffff",
                fontSize: "20px",
                "&.Mui-selected": { color: "white", fontWeight: 800 },
                "&:hover": { backgroundColor: (theme) => theme.palette.axon.subtle },
              }}
            />
          ))}
      </Tabs>
    </SubNavBar>
  ) : null;
}
